'use client'

import { useContext } from 'react'
import { MarketingCapabilitiesContext } from './marketing-capabilities-context'

export function useMarketingCapabilities() {
  const capabilities = useContext(MarketingCapabilitiesContext)

  if (capabilities === null) {
    throw new Error('useMarketingCapabilities must be used within MarketingCapabilitiesProvider')
  }

  return capabilities
}
